import React from "react";
import {
  Box,
  Typography,
  Grid,
  TextField,
  Divider,
} from "@mui/material";
import {
  ExtractedContract,
  SourceValue,
} from "../../../types/contract";
import {
  getDisplayValue,
  isSourceValue,
} from "../../../utils/formatter";

interface DetailEditFormProps {
  detailFields: (keyof ExtractedContract)[];
  labels: Record<string, string>;
  selectedEditableContract: ExtractedContract;
  isEditing: boolean;
  isTrashView: boolean;
  getEditableFieldValue: (contract: ExtractedContract, field: keyof ExtractedContract) => string;
  handleDetailChange: (field: keyof ExtractedContract, value: string) => void;
}

const DetailEditForm: React.FC<DetailEditFormProps> = ({
  detailFields,
  labels,
  selectedEditableContract,
  isEditing,
  isTrashView,
  getEditableFieldValue,
  handleDetailChange,
}) => {
  return (
    <Grid container spacing={2} sx={{ mt: 1 }}>
      {detailFields.map((field) => (
        <React.Fragment key={field}>
          {/* 建物情報の前に区切りを追加 */}
          {field === 'property_address' && (
            <Grid item xs={12}>
              <Divider sx={{ my: 2 }} />
            </Grid>
          )}
          {/* 家主情報の前に区切りを追加 */}
          {field === 'owner_name' && (
            <Grid item xs={12}>
              <Divider sx={{ my: 2 }} />
            </Grid>
          )}
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ px: 2}} //修正
          >
          {field === "co_occupant_info" ? (
            <Box sx={{ mb: 1 }}>
              <Typography
                variant="subtitle2"
                color="text.secondary"
              >
                {labels[field]}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  minHeight: "32px",
                  whiteSpace: "pre-wrap",
                }}
              >
                {getDisplayValue(
                  selectedEditableContract,
                  field
                )}
              </Typography>
              {!isTrashView && (
                <Typography
                  variant="caption"
                  color="text.secondary"
                >
                  (同居者情報の編集は今後のアップデートで対応予定です)
                </Typography>
              )}
            </Box>
          ) : (
            (() => {
              const currentValue = getEditableFieldValue(
                selectedEditableContract,
                field
              );
              return isEditing ? (
                <TextField
                  label={labels[field]}
                  sx={{
                    "& .MuiInputLabel-root": {
                      fontWeight: "bold",
                      fontSize: "16px",
                      color: "rgb(194, 140, 255)",
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      fontWeight: "bold",
                      fontSize: "16px",
                    },
                  }}
                  variant="outlined"
                  size="small"
                  fullWidth
                  multiline
                  value={currentValue === "N/A" ? "" : currentValue}
                  placeholder={currentValue === "" || currentValue === "N/A" ? "N/A" : ""}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    handleDetailChange(field, e.target.value)
                  }
                  disabled={isTrashView}
                  helperText={
                    !isTrashView
                      ? `(参照元: ${
                          isSourceValue(
                            selectedEditableContract[field]
                          )
                            ? (
                                selectedEditableContract[
                                  field
                                ] as SourceValue
                              ).source_document
                            : "N/A"
                        })`
                      : ""
                  }
                />
              ) : (
                <Box sx={{ mb: 1 }}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      color: "rgb(194, 140, 255)",
                      fontWeight: "bold",
                    }}
                  >
                    {labels[field]}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      whiteSpace: "pre-wrap",
                      mb: 0,
                    }}
                  >
                    {currentValue === "" ? "N/A" : currentValue}
                  </Typography>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ mt: 0 }}
                  >
                    (参照元:{" "}
                    {isSourceValue(
                      selectedEditableContract[field]
                    )
                      ? (
                          selectedEditableContract[
                            field
                          ] as SourceValue
                        ).source_document
                      : "N/A"})
                  </Typography>
                </Box>
              );
            })()
          )}
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  );
};

export default DetailEditForm;
